export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  description: string;
  count: number;
  image: string;
}

export const categories: Category[] = [
  {
    id: "cat-1",
    name: "热门推荐",
    slug: "recommended",
    icon: "ri-fire-line",
    description: "精选最受欢迎的动漫资源，每日更新热门榜单，不错过任何一部神作。",
    count: 1280,
    image: "https://readdy.ai/api/search-image?query=Anime%20collection%20with%20popular%20series%20featuring%20vibrant%20characters%2C%20warm%20cinematic%20lighting%2C%20colorful%20illustration%20style%2C%20Japanese%20anime%20art%2C%20clean%20composition%20with%20soft%20warm%20background%20gradients%20orange%20and%20coral%20tones&width=400&height=260&seq=cat-recommended&orientation=landscape",
  },
  {
    id: "cat-2",
    name: "最新上架",
    slug: "latest",
    icon: "ri-rocket-line",
    description: "第一时间获取最新上架的动漫资源，每周更新目录，紧跟追番节奏。",
    count: 356,
    image: "https://readdy.ai/api/search-image?query=Anime%20new%20releases%20collection%20with%20fresh%20modern%20characters%2C%20bright%20energetic%20lighting%2C%20vibrant%20Japanese%20anime%20illustration%20style%2C%20clean%20composition%2C%20warm%20peach%20and%20soft%20yellow%20background%20gradients&width=400&height=260&seq=cat-latest&orientation=landscape",
  },
  {
    id: "cat-3",
    name: "经典番剧",
    slug: "classic",
    icon: "ri-star-line",
    description: "收录口碑最好的经典动漫番剧，重温那些年追过的神作，永不过时的经典。",
    count: 892,
    image: "https://readdy.ai/api/search-image?query=Classic%20anime%20series%20collection%20with%20nostalgic%20characters%2C%20warm%20golden%20lighting%2C%20vintage%20Japanese%20anime%20art%20style%2C%20clean%20elegant%20composition%2C%20soft%20amber%20and%20cream%20background%20gradients&width=400&height=260&seq=cat-classic&orientation=landscape",
  },
  {
    id: "cat-4",
    name: "剧场版",
    slug: "movie",
    icon: "ri-film-line",
    description: "高清剧场版动画电影合集，大银幕级别的视听盛宴，值得反复观看。",
    count: 245,
    image: "https://readdy.ai/api/search-image?query=Anime%20movie%20collection%20with%20cinematic%20characters%2C%20dramatic%20lighting%2C%20theatrical%20Japanese%20anime%20illustration%20style%2C%20grand%20composition%2C%20warm%20coral%20and%20gold%20background%20gradients&width=400&height=260&seq=cat-movie&orientation=landscape",
  },
  {
    id: "cat-5",
    name: "OVA合集",
    slug: "ova",
    icon: "ri-dvd-line",
    description: "精选OVA/特别篇合集，番外剧情与特别内容一网打尽，粉丝必看。",
    count: 178,
    image: "https://readdy.ai/api/search-image?query=Anime%20OVA%20special%20collection%20with%20unique%20characters%2C%20soft%20ambient%20lighting%2C%20detailed%20Japanese%20anime%20illustration%20style%2C%20artistic%20composition%2C%20warm%20rose%20and%20peach%20background%20gradients&width=400&height=260&seq=cat-ova&orientation=landscape",
  },
  {
    id: "cat-6",
    name: "国创动漫",
    slug: "chinese",
    icon: "ri-china-railway-line",
    description: "精选国产动漫佳作，支持国产动画发展，国创崛起之作不容错过。",
    count: 467,
    image: "https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20collection%20with%20elegant%20characters%2C%20warm%20traditional%20lighting%2C%20modern%20Chinese%20anime%20illustration%20style%2C%20clean%20harmonious%20composition%2C%20warm%20red%20and%20gold%20background%20gradients&width=400&height=260&seq=cat-chinese&orientation=landscape",
  },
];